// Styles
import { memoizeFunction, mergeStyles } from "@fluentui/react";
/**
 * Helper to get styles for VirtualContainer
 */ export const virtualContainerStyles = {
    anchor: {
        // Make sure the anchor isn't 0px by 0px to avoid issues with InView not being called on old versions of Edge
        minHeight: "1px"
    }
};
/**
 * Get the classnames associated with the computed styles
 * @param styles The styles for the component
 */ export const getClassNames = memoizeFunction((styles)=>({
        anchor: mergeStyles("virtualContainer-anchor", styles.anchor)
    }));
